<template>
  <div class="instructions">
    <h3 class="h4">Background</h3>
    <p>The “Wheel of Life” exercise is a coaching tool used to create a visual representation of your life balance
       across key areas. Through use of the tool, aspects of your life requiring more focus or attention can be
       visualized and identified. With improved clarity around where your focus should be placed, more effective goals
       can be created, leading to greater success and a more fulfilling life.</p>
    <h3 class="h4">Process Overview</h3>
    <p>
      You will be prompted with two series of life categories ({{ categories.length }} key areas), the first pertaining
      to the present and the second pertaining to the future. Prior to each series you will be given instruction along
      with questions to consider while "scoring" your life across the {{ categories.length }} key areas. While scoring
      each area, you will also be provided a short description of what that domain represents.
    </p>
    <div class="next-step">
      <button class="button filled accent-1 begin"
              @click.prevent="this.$parent.showInstructions = false; this.$parent.workStarted ++; scrollToTop()">
        {{ this.$parent.workStarted ? "Continue" : "Get Started" }}
      </button>
    </div>

    <p class="notice">
      <strong>Notice: </strong>
      <i>The results of this exercise are private. No data is captured nor stored throughout the process. You will be
         prompted to download a PDF of your responses when complete. This PDF is generated on demand and will not be
         saved for future review.</i>
    </p>
  </div>
</template>

<script>
export default {
  props:   {
    showInstructions: {
      type: Boolean
    },
    workStarted:      {
      type: Number
    },
    categories: {
      type: Array
    }
  },
  methods: {
    scrollToTop() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  }
}
</script>
